import React from "react";
import {css} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {NAVIGATION_TEST_IDS} from "@pg-mono/test-ids";

import {HomepageHeroDesktopSearchInput} from "./HomepageHeroDesktopSearchInput";
import {IHomepageSearchViewProps} from "./HomepageSearchTypes";

export const HomepageHeroDesktopSearch = (props: IHomepageSearchViewProps) => {
    return (
        <div className={heroDesktopWrapperStyle}>
            <HomepageHeroDesktopSearchInput {...props} />
            <Button
                type="button"
                variant="filled_primary"
                size="big"
                className={desktopSearchButtonStyle}
                onClick={props.onSearchSubmit}
                disabled={props.isSearchButtonDisabled}
                dataTestId={NAVIGATION_TEST_IDS.SEARCH_BAR.SEARCH_BUTTON}
            >
                SZUKAJ
            </Button>
        </div>
    );
};

const heroDesktopWrapperStyle = css({
    position: "relative",
    display: "none",

    md: {
        display: "grid",
        gridTemplateColumns: "minmax(0, 51.2rem) minmax(0, 20rem)",
        gap: 1.5,
        alignItems: "center",
        justifyContent: "center",
        width: "100%",
        maxWidth: "calc(51.2rem + 20rem + 1.2rem)",
        margin: "0 auto",
        flexGrow: 1,
        flexShrink: 1,
        paddingTop: 0
    }
});

const desktopSearchButtonStyle = css({
    width: "100%",
    maxWidth: "20rem",
    fontWeight: 700,
    textTransform: "uppercase"
});
import React from "react";
import {css} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {NAVIGATION_TEST_IDS} from "@pg-mono/test-ids";

import {HomepageHeroDesktopSearchInput} from "./HomepageHeroDesktopSearchInput";
import {IHomepageSearchViewProps} from "./HomepageSearchTypes";

export const HomepageHeroDesktopSearch = (props: IHomepageSearchViewProps) => {
    return (
        <div className={heroDesktopWrapperStyle}>
            <HomepageHeroDesktopSearchInput {...props} />
            <Button
                type="button"
                variant="filled_primary"
                size="big"
                className={desktopSearchButtonStyle}
                onClick={props.onSearchSubmit}
                disabled={props.isSearchButtonDisabled}
                dataTestId={NAVIGATION_TEST_IDS.SEARCH_BAR.SEARCH_BUTTON}
            >
                SZUKAJ
            </Button>
        </div>
    );
};

const heroDesktopWrapperStyle = css({
    position: "relative",
    display: "none",

    md: {
        display: "grid",
        gridTemplateColumns: "minmax(0, 51.2rem) minmax(0, 20rem)",
        gap: 1.5,
        alignItems: "center",
        justifyContent: "center",
        width: "100%",
        maxWidth: "calc(51.2rem + 20rem + 1.2rem)",
        margin: "0 auto",
        flexGrow: 1,
        flexShrink: 1,
        paddingTop: 0
    }
});

const desktopSearchButtonStyle = css({
    width: "100%",
    maxWidth: "20rem",
    fontWeight: 700,
    textTransform: "uppercase"
});
